<div class='header-container' fxLayout="row" fxLayoutAlign="space-between end">
  <img #img class="header-container__logo" (error)="img.style.display = 'none'" alt="coralogix logo" src="/assets/Coralogix-Logo-Green-circle.svg">
  <span class="header-container__account" *ngIf="showSignUpText">
    <span class="header-container__start-text">Need an account? </span>
    <a href="{{signUpUrl}}">Signup</a>
  </span>
</div>
